import React, { useState } from "react";

const CustomSelect = ({
  label = "",
  placeholder = "Select an option",
  name = "",
  value = "",
  onChange,
  options = [],
  optionValueKey = "id",
  optionLabelKey = "name",
  required = false,
  errorMessage = "This field is required",
  containerClassName = "",
  selectClassName = "",
  errorClassName = "",
  disabled = false,
  showReset = false,
  mode = "dark",
}) => {
  const [touched, setTouched] = useState(false);

  const isError = required && touched && !value;

  const handleReset = () => {
    const syntheticEvent = {
      target: {
        name,
        value: "",
      },
    };
    onChange(syntheticEvent);
    setTouched(false);
  };

  return (
    <div className={`flex flex-col w-full ${containerClassName}`}>

      {/* LABEL */}

      {label && (
        <label className="text-sm text-gray-600 mb-1">
          {label} {required && "*"}
        </label>
      )}

      {/* SELECT */}

      <div className="flex items-center gap-2 w-full">

        <select
          disabled={disabled}
          name={name}
          value={value}
          onChange={(e) => {
            onChange(e);
            setTouched(true);
          }}
          onBlur={() => setTouched(true)}
          className={`
            w-full
            px-3 py-2
            rounded-md
            border
            ${mode === "dark" ? "bg-[#1f1f1f]" : "bg-white"}
            ${mode === "dark" ? "text-white" : "text-black"}
            border-gray-600
            focus:border-[#FBB033]
            focus:outline-none
            transition
            ${disabled ? "opacity-50 cursor-not-allowed" : ""}
            ${isError ? "border-red-500" : ""}
            ${selectClassName}
          `}
        >
          <option value="" className="bg-[#1f1f1f] text-gray-400">
            {placeholder}
          </option>

          {options.map((item, i) => (
            <option
              key={i}
              value={typeof item === "string" ? item : item[optionValueKey]}
              className="bg-[#1f1f1f] text-white"
            >
              {typeof item === "string" ? item : item[optionLabelKey]}
            </option>
          ))}
        </select>

        {/* RESET BUTTON */}

        {showReset && value && !disabled && (
          <button
            type="button"
            onClick={handleReset}
            className="text-xs px-2 py-1 border border-gray-500 rounded text-gray-300 hover:text-white hover:border-gray-300"
          >
            Reset
          </button>
        )}
      </div>

      {/* ERROR */}

      {isError && (
        <p className={`text-red-500 text-xs mt-1 ${errorClassName}`}>
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default CustomSelect;